import { getPartnersOptions } from '@/services/queryOptions/partnerQueryOptions';
import { useQuery } from '@tanstack/react-query';
import React from 'react';
import { XDaoContent } from './XDaoContent';

export default function XDao() {
    const { data: partners, isLoading: isLoadingPartner, isError, error, refetch } = useQuery(getPartnersOptions());

    return (
        <XDaoContent
            partners={partners}
            isLoading={isLoadingPartner}
            isError={isError}
            errorMessage={error?.message}
            onRetry={() => refetch()}
        />
    );
}
